import {useCallback} from 'react';
import {BillInterface} from '../../interfaces/customer/BillInterface';
import {formatNumber, formatDate} from '../../utils/Utils';

const generateBillHTML = (bill: BillInterface): string => {
    let totalWeight = 0;
    let totalVolume = 0;
    let totalCount = 0;
    let totalSum = 0;

    const rows = bill.positions.map((position, index) => {
        const weight = position.product.weight * position.cnt;
        const volume = position.product.volume * position.cnt;
        const sum = position.total.amount;

        totalWeight += weight;
        totalVolume += volume;
        totalCount += position.cnt;
        totalSum += sum;

        return `
        <tr>
            <td class="text-center">${index + 1}</td>
            <td>${position.product.code}</td>
            <td>${position.product.name}</td>
            <td class="text-center">шт.</td>
            <td class="text-end">${position.cnt}</td>
            <td class="text-end">${formatNumber(weight)}</td>
            <td class="text-end">${formatNumber(volume)}</td>
            <td class="text-end">${formatNumber(position.price.amount)}</td>
            <td class="text-end">${formatNumber(sum)}</td>
        </tr>`;
    }).join('');

    return `<!DOCTYPE html>
<html>
<head>
    <meta charset="utf-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <title>Pride - система размещения заказов</title>
    <meta content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" name="viewport">
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
    <style>
        body { padding: 20px; }
        h1 { margin-bottom: 20px; }
        .table { width: 100%; }
        .table th, .table td { padding: 8px; }
        nobr { white-space: nowrap; }
    </style>
</head>
<body>
<div class="container">
    <h1>Счет № ${bill.bill_id} от ${formatDate(bill.create_date).split(' ')[0]}</h1>
    <table class="table">
        <tr style="background-color: #e3e3e3; border-bottom: 2px solid black;">
            <th class="text-center"><nobr>№ п/п</nobr></th>
            <th>Код</th>
            <th>Наименование</th>
            <th class="text-center">Ед.изм.</th>
            <th class="text-center">Количество</th>
            <th class="text-end"><nobr>Вес, кг</nobr></th>
            <th class="text-end"><nobr>Объем, м<sup>3</sup></nobr></th>
            <th class="text-end"><nobr>Цена, руб.</nobr></th>
            <th class="text-end"><nobr>Сумма, руб.</nobr></th>
        </tr>
        ${rows}
        <tr style="background-color: #e3e3e3; border-top: 2px solid black;">
            <th colspan="4">ИТОГО:</th>
            <th class="text-end">${totalCount}</th>
            <th class="text-end">${formatNumber(totalWeight)}</th>
            <th class="text-end">${formatNumber(totalVolume)}</th>
            <th>&nbsp;</th>
            <th class="text-end">${formatNumber(totalSum)}</th>
        </tr>
    </table>
</div>
</body>
</html>`;
};

export const useBillPrint = (bill: BillInterface) => {
    const printBill = useCallback(() => {
        const html = generateBillHTML(bill);
        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.write(html);
            printWindow.document.close();
        }
    }, [bill]);

    return {printBill};
};